var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ui-empty-state" },
    [
      _c(
        "div",
        { staticClass: "ui-empty-state__icon ui-layout ui-alignment-center" },
        [_c("i", { class: _vm.icon })]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "ui-empty-state__label ui-layout ui-alignment-center ui-headline",
        },
        [_c("div", [_vm._v(_vm._s(_vm.label))])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "ui-empty-state__description ui-layout ui-alignment-center ui-headline-body-1",
        },
        [_c("div", [_vm._v(_vm._s(_vm.description))])]
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }